const isProduction = process.env.NODE_ENV === 'production';
export const API_BASE_URL = isProduction
? 'https://api.bsparksoftwaretechnologies.com/api'
: 'http://localhost:5001/api' ;

export const API = {
    BASE: API_BASE_URL,
    LOGIN: `${API_BASE_URL}/users/login`,
    USER: `${API_BASE_URL}/users`,
    PRODUCT: `${API_BASE_URL}/products`,
}